import api from '../api';

const absoluteUrlRegex = /^https?:\/\//i;

export const getApiBase = () => {
  const baseURL = api?.defaults?.baseURL;
  if (baseURL) {
    try {
      return new URL(baseURL);
    } catch (error) {
      try {
        return new URL(baseURL.endsWith('/') ? baseURL : `${baseURL}/`);
      } catch (nestedError) {
        // Ignore malformed base URLs
      }
    }
  }

  if (typeof window !== 'undefined') {
    try {
      return new URL(window.location.origin);
    } catch (error) {
      // Ignore failures when window is unavailable
    }
  }

  return null;
};

export const isAbsoluteUrl = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  return absoluteUrlRegex.test(value);
};

export const normalizeStoredUrl = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }

  if (isAbsoluteUrl(trimmed)) {
    try {
      const base = getApiBase();
      if (base) {
        const parsed = new URL(trimmed);
        if (parsed.host === base.host) {
          const normalizedPath = `${parsed.pathname}${parsed.search}`;
          return normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;
        }
      }
    } catch (error) {
      // Keep absolute URL if it cannot be parsed
      return trimmed;
    }

    return trimmed;
  }

  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const resolveAssetUrl = (value) => {
  const normalized = normalizeStoredUrl(value);
  if (!normalized) {
    return '';
  }

  if (isAbsoluteUrl(normalized)) {
    return normalized;
  }

  const base = getApiBase();
  if (!base) {
    return normalized;
  }
  try {
    const relative = normalized.startsWith('/') ? normalized : `/${normalized}`;
    const url = new URL(relative, base.origin);
    const basePath = base.pathname.replace(/\/+$/, '');
    const prefix = basePath && basePath !== '/' ? basePath : '';
    url.pathname = `${prefix}${url.pathname}`.replace(/\/{2,}/g, '/');
    return url.toString();
  } catch (error) {
    return normalized;
  }
};
